import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';

const ServicesQuote: React.FC = () => (
  <section className="py-20 bg-white">
    <div className="container-main">
      <div className="text-center mb-14">
        <span className="section-label">Get In Touch</span>
        <h2 className="section-heading mt-2">Request a Free Quote</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
        {[
          { icon: <LocationOnIcon fontSize="large" />, title: 'Our Location', lines: ['130041 New Stands, Chizhanje', 'Mabvuku, Harare, Zimbabwe'] },
          { icon: <PhoneIcon fontSize="large" />, title: 'Direct Line Numbers', lines: ['(+263) 77 413 4805'] },
          { icon: <EmailIcon fontSize="large" />, title: 'Our Email', lines: ['sales@manlab.co.zw'] },
        ].map(item => (
          <div key={item.title} className="card p-8 text-center bg-light border-0 shadow-none">
            <div className="w-14 h-14 bg-white shadow-sm rounded-full flex items-center justify-center mx-auto mb-5 text-primary">
              {item.icon}
            </div>
            <h3 className="font-bold text-primary mb-3">{item.title}</h3>
            {item.lines.map(l => <p key={l} className="text-gray-500 text-sm">{l}</p>)}
          </div>
        ))}
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="card p-10 shadow-xl border border-gray-100">
          <h3 className="section-heading text-2xl text-center mb-2">Get A Free No-Obligation Quote</h3>
          <p className="text-gray-500 text-sm text-center mb-8">Simply fill out the form below and our team will respond within 24 hours.</p>
          <form className="space-y-4" onSubmit={e => e.preventDefault()}>
            <div className="grid sm:grid-cols-2 gap-4">
              <input type="text" placeholder="Your Name" className="w-full px-5 py-3.5 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent bg-gray-50/50" />
              <input type="email" placeholder="Email Address" className="w-full px-5 py-3.5 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent bg-gray-50/50" />
            </div>
            <input type="text" placeholder="Company / Organisation" className="w-full px-5 py-3.5 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent bg-gray-50/50" />
            <input type="text" placeholder="Product(s) Required" className="w-full px-5 py-3.5 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent bg-gray-50/50" />
            <textarea rows={5} placeholder="Additional details or requirements..." className="w-full px-5 py-3.5 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-accent bg-gray-50/50 resize-none" />
            <button type="submit" className="btn-primary w-full justify-center py-4 text-base mt-2 shadow-lg shadow-accent/20">
              Submit Quote Request <SendIcon />
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
);

export default ServicesQuote;
